<template>
	<div v-if="user.hasRole(['manager', 'admin'])">
		<navbar
			@reload="reload"
			:data="item"
			:user="user"
			:type="'edit'"
			:isAuth="isAuth">
		</navbar>

		<div v-if="item" class="row">
			<div class="col-md-12">
				<projects-datatable
					ref="datatable"
					:user="user"
					:isAuth="isAuth"
					:customer="item">
				</projects-datatable>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	import Navbar from './Navbar.vue'
	import ProjectsDatatable from '@/components/projects/projects/views/Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
			'projects-datatable': ProjectsDatatable,
		},
		data () {
			return {
				item: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
					this.$nextTick( () => {
						this.$refs.datatable.datatable.moreParams.filter.customer_id = this.item.id
					})
					this.$nextTick( () => this.$refs.datatable.reload())
				}).catch(function(response) {
					console.log(response)
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Projects.vue